import { z } from 'my-zod'
import { customersModel } from './customers-model'

export const customerEditView = customersModel.pick({
  id: true,
  ssoEmail: true,
  firstName: true,
  lastName: true,
  helmetSize: true,
  notes: true,
  email: true,
  secondaryEmail: true,
  addressLine1: true,
  addressLine2: true,
  city: true,
  state: true,
  postalCode: true,
  primaryPhone: true,
  country: true,
  hasMotorcycleLicense: true,
  lastModifiedDate: true,
  createdDate: true,
  driverLicenseCountry: true,
  driverLicenseState: true,
  driverLicenseExpirationDate: true,
  driverLicenseNumber: true,
  DOB: true
})
export type customerEditView = z.infer<typeof customerEditView>
